module.exports = __webpack_public_path__ + "img/featured-placeholder2.e403cede.jpg";